/**
 * Vue3.0自定义滚动条组件V3Scroll
 */
import V3Scroll from './scroll.vue'
V3Scroll.install = (app) => {app.component('v3-scroll', V3Scroll)
}
export default V3Scroll